import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const starColors: ThemeTailwindType = {
    '--primary': '47 100% 50%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '222 47% 11%',
};

const colorPalette: ColorPaletteType = {
    primary: '#072d4f',
    secondary: '#fdc500',
    tertiary: '#055ca9',
    dark: '#020d16',
    shade1: '#34536f',
    shade2: '#61798f',
    shade3: '#a4b2bf',
    shade4: '#c1ccd7',
    shade5: '#e8ebef',
    shade6: '#f2f2f2',
    textDark: '#111111',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.secondary,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.primary,
        bgColorQuaternary: colorPalette.primary,

        borderColor: colorPalette.primary,
        borderColorSecondary: colorPalette.primary,

        txtColor: colorPalette.textDark,
        txtColorSecondary: colorPalette.textDark,
        txtColorTertiary: colorPalette.white,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.textDark,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: colorPalette.primary,
        bgColorSecondary: '#351059',
        bgColorTertiary: colorPalette.secondary,
        txtColor: colorPalette.secondary,
        txtColorSecondary: colorPalette.white,
        txtColorTertiary: colorPalette.dark,
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#0A1C30',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#FEBE10',
        buttonTxtColor: '#0A1C30',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
